import { Button, Modal } from 'antd';
import { strings } from '../../../lang';
import { useLoadingGuard } from '../../../hooks/use-loading-guard';
import { DoNotCloseTag } from '../../common/donotclose-tag';

export interface AssignmentConflictModalProps {
  open: boolean;
  /** Display name of the customer the agent is still assigned to. */
  oldCustomerName?: string;
  /** Load the already-assigned (old) customer so the agent can complete it. */
  onProceedWithOld: () => Promise<void>;
  /** Complete the old customer as NotReached, then assign the new one from the link. */
  onChooseNew: () => Promise<void>;
}

export const AssignmentConflictModal = ({ open, oldCustomerName, onProceedWithOld, onChooseNew }: AssignmentConflictModalProps) => {
  const [isLoading, guard] = useLoadingGuard();

  const handleProceedOld = () => guard(onProceedWithOld);
  const handleChooseNew = () => guard(onChooseNew);

  const displayName = oldCustomerName?.trim() || strings.assignmentConflict.thisCustomer;

  return (
    <Modal
      title={strings.assignmentConflict.title}
      centered
      closable={false}
      maskClosable={false}
      keyboard={false}
      open={open}
      footer={[
        <Button key="old" onClick={handleProceedOld} disabled={isLoading} loading={isLoading}>
          {strings.assignmentConflict.keepOldButton}
        </Button>,
        <Button key="new" type="primary" onClick={handleChooseNew} disabled={isLoading} loading={isLoading}>
          {strings.assignmentConflict.switchNewButton}
        </Button>,
      ]}
    >
      <p>{strings.formatString(strings.assignmentConflict.body, displayName)}</p>
      <p>{strings.assignmentConflict.newCustomerNote}</p>
      {isLoading && <DoNotCloseTag />}
    </Modal>
  );
};
